import type * as ents from '@attain-apps/entities'
import * as store from '@attain-apps/fe/web/main/lib/store'

import type * as models from '../../models'

import { State } from './state'

/**
 * Core actions for this feature
 */
// NOTE: intentionally missing return type so that type can be inferred
export function getActionsConfig() {
  return {
    /* eslint-disable sort-keys */
    executeAction: store.actions.request({
      input: store.actions.Data.asIs<{
        context: models.action.Handler.Context
      }>(),
      output:
        store.actions.Data.asIs<
          Partial.Semi<ents.core.mosaic.Action.ExecutionResult, 'id' | 'alias'>
        >(),
      reducers: {
        request: ({ state, data: { context } }) =>
          // TODO: remove this once we step away from full screen loader
          // Skip adding ongoing request on initial action execution
          // The confirmation result will determine if a loader should be displayed
          !context.actionRef.confirm
            ? State.addOngoingRequest(state, context)
            : state,
        error: ({
          state,
          data: {
            request: {
              context: { id },
            },
          },
        }) => State.deleteOngoingRequest(state, id),
        success: ({
          state,
          data: {
            request: {
              context: { id },
            },
          },
        }) => State.deleteOngoingRequest(state, id),
        cancellation: ({
          state,
          data: {
            request: {
              context: { id },
            },
          },
        }) => State.deleteOngoingRequest(state, id),
      },
    }),
    confirmAction: store.actions.request({
      // TODO: confirm should required confirmation
      // 'Required.semi<ents.core.mosaic.Action.Ref, 'confirm'>'
      input: store.actions.Data.asIs<{
        context: models.action.Handler.Context
      }>(),
      output: store.actions.Data.NONE,
      reducers: {
        request: ({ state, action }) =>
          State.setConfirmationRequest(state, action),
        error: ({ state, data }) =>
          State.deleteConfirmationRequest(state, data.request.context.id),
        success: ({ state, data }) => {
          // TODO: remove this once we step away from full screen loader
          // Currently we consider that we are in "loading" state, only if we hit" confirm button
          if (data.request.context.actionRef.confirm) {
            State.addOngoingRequest(state, data.request.context)
          }
          return State.deleteConfirmationRequest(state, data.request.context.id)
        },
        cancellation: ({ state, data }) =>
          State.deleteConfirmationRequest(state, data.request.context.id),
      },
    }),
    submitAction: store.actions.request({
      input: store.actions.Data.asIs<
        models.action.Context & {
          handlerId: models.action.Handler.Id
        }
      >(),
      output:
        store.actions.Data.asIs<ents.core.mosaic.Action.ExecutionResult>(),
    }),
    /* eslint-enable sort-keys */
  } as const satisfies store.actions.Config.Constraint<State>
}
